var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGamepad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57215 4.2791C4.1872 3.9406 1.25 6.59874 1.25 10.0006V15.9412C1.25 20.5049 7.12464 22.3568 9.74178 18.618L10.026 18.2119C11.1877 16.5524 13.6641 16.6096 14.7479 18.3209C17.0724 21.9912 22.75 20.3445 22.75 16.0001V10.0006C22.75 6.59873 19.8128 3.9406 16.4279 4.2791L12.5224 4.66964C12.175 4.70438 11.825 4.70438 11.4776 4.66964L7.57215 4.2791ZM19 9.97559C19 10.5279 18.5523 10.9756 18 10.9756C17.4477 10.9756 17 10.5279 17 9.97559C17 9.4233 17.4477 8.97559 18 8.97559C18.5523 8.97559 19 9.4233 19 9.97559ZM16 13.9756C16.5523 13.9756 17 13.5279 17 12.9756C17 12.4233 16.5523 11.9756 16 11.9756C15.4477 11.9756 15 12.4233 15 12.9756C15 13.5279 15.4477 13.9756 16 13.9756ZM8 8.72559C8.41421 8.72559 8.75 9.06137 8.75 9.47559V10.7256H10C10.4142 10.7256 10.75 11.0614 10.75 11.4756C10.75 11.8898 10.4142 12.2256 10 12.2256H8.75V13.4756C8.75 13.8898 8.41421 14.2256 8 14.2256C7.58579 14.2256 7.25 13.8898 7.25 13.4756V12.2256H6C5.58579 12.2256 5.25 11.8898 5.25 11.4756C5.25 11.0614 5.58579 10.7256 6 10.7256H7.25V9.47559C7.25 9.06137 7.58579 8.72559 8 8.72559Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamepad);
export default __webpack_public_path__ + "static/media/Gamepad.acd203c8d29493d3a991442e04add89b.svg";
export { ForwardRef as ReactComponent };